export const DEFAULT_SERVICE_TIMES = [
  {
    id: 'tuesday',
    day: 'Tuesday',
    details: [
      { id: 'prayer', description: 'Prayer Meeting', time: '8:00 PM', location: '(Online)' },
    ],
  },
  {
    id: 'friday',
    day: 'Friday',
    details: [
      { id: 'prayer', description: 'Prayer Meeting', time: '7:30 PM', location: '(In-Person @ Church)' },
    ],
  },
  {
    id: 'saturday',
    day: 'Saturday',
    details: [
      { id: 'prayer', description: 'Prayer Meeting', time: '6:30 PM', location: '(In-Person @ Church)' },
    ],
  },
  {
    id: 'sunday',
    day: 'Sunday',
    details: [
      { id: 'school', description: 'Sunday School', time: '9:00 AM', location: '' },
      { id: 'service', description: 'Sunday Service', time: '9:45 AM', location: '(In-Church & Online)' },
    ],
  },
];

function createId(prefix) {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}

export function resolveServiceTimes(getContent) {
  const stored = getContent('home.services.items', null);
  return Array.isArray(stored) && stored.length > 0 ? stored : DEFAULT_SERVICE_TIMES;
}

export function createEmptyService() {
  return {
    id: createId('service'),
    day: 'New Day',
    details: [
      { id: createId('detail'), description: 'New meeting', time: '7:00 PM', location: '' },
    ],
  };
}

export function createEmptyDetail() {
  return {
    id: createId('detail'),
    description: 'New meeting',
    time: '7:00 PM',
    location: '',
  };
}
